import icon from './share_of_voice.png.js';
import template from './graph_widget_view.html';
import templateMaxView from './graph_widget_max.html';
import templateReportView from './graph_widget_report.html';

angular.module('MW.InsDashboard.sovWidget', [
    'MW.Dashboard.DashboardWidgetService',
    'MW.Framework.TranslationService',
    'MW.InsDashboard.insightsBackendService',
    'MW.InsDashboard.ChartService',
    'DashboardChartConfigService',
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.Framework.CoreCommon',
    'MW.InsDashboard.InsightsDataMaps',
    'MW.InsDashboard.TransformSegment',
    'MW.InsDashboard.ChartDataService',
    'CoreChartObject',
    'MW.InsDashboard.WidgetController',
    'MW.Configuration',
    'MW.Framework.CoreUserService'
])
.directive('sovWidget', [
    'DashboardWidgetService',
    'translationService',
    'insightsBackendService',
    'ChartService',
    '$filter',
    '$q',
    'DashboardChartConfigService',
    'InsWidgetConfigService',
    'CoreCommon',
    'InsightsDataMaps',
    'TransformSov',
    'ChartDataService',
    'CoreChartObject',
    '$controller',
    'CoreUserService',
    function(DashboardWidgetService, translationService, insightsBackendService, ChartService, $filter, $q, DashboardChartConfigService, InsWidgetConfigService, CoreCommon, InsightsDataMaps, TransformSov,ChartDataService, CoreChartObject, $controller, CoreUserService){

    var sovWidget = DashboardWidgetService.getWidget('sov-widget');

    sovWidget.editViewFile = 'graph_widget_view';
    sovWidget.userViewFile = 'graph_widget_view';
    sovWidget.maximizedViewFile = 'graph_widget_max';
    sovWidget.reportViewFile = 'graph_widget_report';


    var sovWidgetController = function($scope){

        $controller('WidgetController', {$scope: $scope});//inject the scope and use the basic widget controller

    };

    var sovWidgetLink = function(scope, element) {

        var chartOverrides = {
            user:{},
            max:{}
        };

        var settingsOverides = {
            fetchDataForPreviousRange: scope.widget.settings.dateComparison,
            yAxisTitle: 'Share'
        };


        var chartConfiguration = {
            insightsService: 'statisticServiceDateHistogram',
            insightsObject: 'dateHistograms',
            charts:{
                areaspline:{ chart:ChartService.area,transform:TransformSov.areaspline, dataMap:InsightsDataMaps.datamapDateVolume, custom: chartOverrides},
                spline:{ chart:ChartService.line,transform:TransformSov.spline, dataMap:InsightsDataMaps.datamapDateVolume, custom: chartOverrides, customSettings: settingsOverides},
                donut:{ chart:ChartService.donut,transform:TransformSov.donut, dataMap:InsightsDataMaps.datamapDateVolume, custom: chartOverrides},
                column:{ chart:ChartService.column,transform:TransformSov.column, dataMap:InsightsDataMaps.datamapDateVolume, custom: chartOverrides},
                table: {chart:{},transform:TransformSov.table,dataMap:InsightsDataMaps.datamapDateVolume}
            },
            table: {
                enabled: true,
                rowTitle: translationService.getLocalizedString('Date'),
                summaryTitle: translationService.getLocalizedString('Total'),
                titleField: 'name',
                countField: 'volume',
                percentField: 'sov',
                drilldown: function sovTableDrilldown(datapoint){
                    scope.internalDrillDown(datapoint.id,datapoint.date);
                },
                tooltip: function sov_table_tooltip(datapoint){
                    return translationService.getLocalizedString('Volume') +': ' + datapoint.volume + ' - ' + translationService.getLocalizedString('SOV') + ': ' + datapoint.sov;
                },
                customRowTitleSort: true
            }
        };

        if (scope.widget.settings && scope.widget.settings.previousDateRange && scope.widget.settings.dateComparison) {
            chartConfiguration['previousDateStart'] = moment(scope.widget.settings.previousDateRange.startDate).tz(CoreUserService.getTimezone()).format();
            chartConfiguration['previousDateEnd'] = moment(scope.widget.settings.previousDateRange.endDate).tz(CoreUserService.getTimezone()).format();
        }

        scope.initWidget(chartConfiguration);
    };

    return new WidgetDirective(sovWidget, sovWidgetLink, sovWidgetController);
}])
.run(['DashboardWidgetService', 'translationService', 'InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function (DashboardWidgetService, translationService, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {
    DashboardWidgetService.register({
        name: translationService.getLocalizedString('Share of Voice (SOV)'),
        app: 'ins_dashboard',
        description: translationService.getLocalizedString('The Share of Voice widget provides insight into how much media ' +
                                                           'coverage a brand or product gets relative to its competition. ' +
                                                           'Results can be displayed in volume or percentage. Filters can be ' +
                                                           'applied to focus on specific markets of interest. The widget can ' +
                                                           'be used to benchmark up to 5 different brands or products.'),
        directive: 'sov-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            source: [],
            'maxAgents': 5
        },
        displayOrder: 5,
        allowExport: true,
        requiredSettings: ['dateRange'],
        availableSettings: ['dateRange', 'title', 'news', 'social','broadcast', 'rss','tags', 'chartType', 'labelFormat', 'dateBreakouts', 'labelVisibility', 'dateComparison'],
        availableChartTypes:[
            {name:'Line',id:'spline'},
            {name:'Bar',id:'column'},
            {name:'Area',id:'areaspline'},
            {name:'Donut',id:'donut'}
        ],

        getDefaultChartType: function() {
            return this.availableChartTypes[1];
        },
        hasRequiredSettings: function(){
            var _widget = this;
            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });

}]);

